import React from 'react';
import { Button, Input, Modal, ModalDialog, ModalClose, Typography, Tooltip } from '@mui/joy';
import { ArrowCircleUp } from '@mui/icons-material';
import { useDispatch } from 'react-redux';


export default function UploadButton(){
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [success, setSuccess] = React.useState(true);
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result;
            try {
                const jsonData = JSON.parse(content);
                dispatch({ type: 'HYDRATE', payload: jsonData });
                setSuccess(true);
                setOpen(false);

            }
            catch (error) {
                console.error('Invalid JSON file:', error);
                setSuccess(false);
                return;
            }
            
            // Handle the file content here
            // For example, you can parse JSON or update the state
        };
        reader.readAsText(file);

    };




    return (

    <React.Fragment>
        <Tooltip title="Upload a JSON file to restore state" placement="top">
            <Button variant="outlined" component="span" onClick={() => setOpen(true)}>
                    <ArrowCircleUp/>
            </Button>
        </Tooltip>
        <Modal
        open={open}
        onClose={(_event, reason) => {
            setOpen(false);
          }}>
            <ModalDialog>
                <Typography level="h2" fontSize="lg" sx={{ mb: 2 }}>
                    Upload a JSON File to restore working state
                </Typography>
                {success ? null : <Typography level="body2" sx={{ mb: 2 }} color='danger'>
                    File upload failed
                    </Typography>
                }
                <Input type='file' accept='.json' onChange={handleFileUpload}></Input>
            <ModalClose />
            </ModalDialog>
        </Modal>
    </React.Fragment>
    )
}